/** Tidy docling markdown for READ-ONLY display only (never the stored text the
 *  agents read or the fields were extracted from): drop the `<!-- image -->`
 *  figure placeholders docling emits — they render as raw junk — and collapse the
 *  blank lines they leave. Shared by the tech-spec source pane and the
 *  supporting-document preview. */
export function cleanMarkdownForDisplay(md: string | null): string | null {
  if (!md) return md;
  return md.replace(/<!--[\s\S]*?-->/g, '').replace(/\n{3,}/g, '\n\n').trim();
}
